<template>
  <j-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :bodyStyle="bodyStyle"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <a-spin :spinning="confirmLoading">
      <div class="form-contain" style="height: auto">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane v-for="item in tabList" :key="item.key" :tab="$t(item.title)">
            <div v-if="activeKey == 1" style="height: calc(70vh - 90px);overflow-y: auto;">
              <a-divider orientation="left">
                {{ $t('基本数据') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('接收时间')">
                  {{model.sysTime}}
                </detail-list-item>
                <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
                <!-- <detail-list-item term="IMEI号" v-if="model.meterType==80">{{model.meterImei}}</detail-list-item> -->
                <!--
                <detail-list-item term="表类型">
                  {{$t(meterTypeObj[model.meterType])}}
                </detail-list-item>
                -->
                <detail-list-item :term="$t('表端时间')">
                  {{model.meterTime}}
                </detail-list-item>
                <detail-list-item :term="$t('电池电压(V)')">
                  {{model.meterBatteryVoltage}}
                </detail-list-item>
                <detail-list-item :term="$t('累计发送成功次数')" v-if="model.meterType==80">
                  {{model.sumSuccessCount}}
                </detail-list-item>
                <detail-list-item :term="$t('累计发送失败次数')" v-if="model.meterType==80">
                  {{model.sumFailedCount}}
                </detail-list-item>
                <detail-list-item :term="$t('当前累积量(m³)')">
                  {{model.meterTotalUse}}
                </detail-list-item>

                <template v-if="model.meterType==80">
                  <!--
                  <detail-list-item term="日最高流量(m³)">
                    {{model.meterDayHighFlow}}
                  </detail-list-item>
                  -->
                  <detail-list-item :term="$t('内核温度(℃)')">
                    {{model.innerTemp}}
                  </detail-list-item>
                  <detail-list-item :term="$t('试用量(m³)')">
                    {{model.meterTestUse==255?$t('未启用'):model.meterTestUse}}
                  </detail-list-item>
                  <detail-list-item :term="$t('定时上报周期')">
                    {{model.meterUpCycle}}
                  </detail-list-item>
                  <detail-list-item :term="$t('单价(元)')">
                    {{model.meterPrice}}
                  </detail-list-item>
                  <detail-list-item :term="$t('充值次数')">
                    {{model.meterPayTimes}}
                  </detail-list-item>
                  <detail-list-item :term="$t('本次通讯耗时(s)')">
                    {{model.meterUpConnNetTime}}
                  </detail-list-item>
                  <detail-list-item :term="$t('当前剩余金额(元)')">
                    {{model.meterRemainNum}}
                  </detail-list-item>
                  <detail-list-item :term="$t('报警金额(元)')">
                    {{model.meterWarnMoney}}
                  </detail-list-item>
                  <detail-list-item :term="$t('剩余金额状态')">
                    {{model.remainMoneyFlag==0?$t('剩余金额正常'):model.remainMoneyFlag==1?$t('剩余金额到达报警金额'):model.remainMoneyFlag==2?$t('剩余金额到达透支金额'):'--'}}
                  </detail-list-item>
                </template>
                <template v-if="model.meterType=='MN100-2D'">
                  <detail-list-item :term="$t('水压(MPa)')">
                    {{model.meterSoftVersion}}
                  </detail-list-item>
                  <detail-list-item :term="$t('瞬时流量(m³/h)')">
                    {{model.meterTestUse}}
                  </detail-list-item>
                </template>
              </detail-list>
              <a-divider orientation="left">
                {{ $t('表端状态信息') }}
              </a-divider>

              <detail-list>
                <detail-list-item :term="$t('日冻结数据(m³)')">
                  {{model.meterDayUse<0?'--':model.meterDayUse}}
                </detail-list-item>

                <detail-list-item :term="$t('状态字信息')">
                  <span>ST0:&nbsp;{{model.meterStatus1==''||model.meterStatus1==null?model.meterStatus1:model.meterStatus1.toString(16)}}</span>
                  <span>;ST1:&nbsp;{{model.meterStatus2==''||model.meterStatus2==null?model.meterStatus2:model.meterStatus2.toString(16)}}</span>
                  <span>;ST2:&nbsp;{{model.meterStatus3==''||model.meterStatus3==null?model.meterStatus3:model.meterStatus3.toString(16)}}</span>
                  <span>;ST3:&nbsp;{{model.meterStatus4==''||model.meterStatus4==null?model.meterStatus4:model.meterStatus4.toString(16)}}</span>
                </detail-list-item>

                <detail-list-item :term="$t('存储状态')">
                  {{model.meterSaveFault==0?$t('正常'):model.meterSaveFault==1?$t('故障'):''}}
                </detail-list-item>
                <detail-list-item :term="$t('电池状态')">
                  {{model.meterBatteryStatus==0?$t('正常'):model.meterBatteryStatus==1?$t('欠压'):''}}
                </detail-list-item>
                <detail-list-item :term="$t('上报方式')">
                  {{SendWayObj[model.meterUpWay]?$t(SendWayObj[model.meterUpWay]): $t('未知')}}
                </detail-list-item>
                <detail-list-item :term="$t('上报次数')">
                    {{model.meterUpTimes+1}}
                  </detail-list-item>
                <detail-list-item :term="$t('磁干扰')">
                  {{model.meterMagetic==0?$t('正常'):model.meterMagetic==1?$t('有'):''}}
                </detail-list-item>
                <!--
                <detail-list-item term="运营商">
                  {{$t(netTypeObj[model.meterIotType])}}
                </detail-list-item>
                -->
                <template v-if="model.meterType==80">
                  <detail-list-item :term="$t('解卡功能有无异常')">
                    {{model.meterCardState==0?$t('无'):model.meterCardState==1?$t('有'):''}}
                  </detail-list-item>
                  <!--
                  <detail-list-item term="表端是否计费">
                    {{model.meterCalFee==0?'表端不计费':model.meterCalFee==1?'表端计费':''}}
                  </detail-list-item>
                  -->
                  <detail-list-item :term="$t('表端工作模式')">
                    {{model.meterWorkModel==0?$t('调试模式'):model.meterWorkModel==1?$t('用户模式'):''}}
                  </detail-list-item>
                  <detail-list-item :term="$t('阀门状态')">
                    {{Mn100FkStatusObj[model.meterValveStatus]?$t(Mn100FkStatusObj[model.meterValveStatus]):''}}
                  </detail-list-item>
                  <detail-list-item :term="$t('阀门卡控制有无')">
                    {{model.meterHasValveCardControll==0?$t('无'):model.meterHasValveCardControll==1?$t('有'):''}}
                  </detail-list-item>
                  <detail-list-item :term="$t('阀门是否有故障')">
                    {{model.meterValveFault==0?$t('正常'):model.meterValveFault==1?$t('有故障'):''}}
                  </detail-list-item>
                  <detail-list-item :term="$t('阀控状态')">
                    {{model.meterHasValveControll==0?$t('无阀控'):model.meterHasValveControll==1?$t('有阀控'):''}}
                  </detail-list-item>
                  <detail-list-item :term="$t('终端协议版本号')">
                    {{model.meterSoftVersion}}
                  </detail-list-item>
                </template>
                <detail-list-item :term="$t('流速(m³/h)')" v-if="model.meterType==20">
                  {{model.meterJsrUse}}
                </detail-list-item>
              </detail-list>
              <a-divider orientation="left">
                {{ $t('表端信号状态') }}
              </a-divider>
              <detail-list>
                <detail-list-item :term="$t('接收信号功率(RSRP)')">
                  {{model.meterSignalStrength.RSRP!=null?model.meterSignalStrength.RSRP:'--'}}dBm
                </detail-list-item>
                <detail-list-item :term="$t('信噪比(SNR)')">
                  {{model.meterSignalStrength.SNR!=null?model.meterSignalStrength.SNR:'--'}}dB
                </detail-list-item>
                <detail-list-item :term="$t('信号强度(CSQ)')">
                  {{model.meterSignalStrength.CSQ!=null?model.meterSignalStrength.CSQ:'--'}}
                </detail-list-item>
                <detail-list-item :term="$t('覆盖等级(ECL)')">
                  {{model.meterSignalStrength.ECL!=null?model.meterSignalStrength.ECL:'--'}}
                </detail-list-item>
                <detail-list-item :term="$t('小区ID(CellID)')">
                  {{model.meterSignalStrength.CellID!=null?model.meterSignalStrength.CellID: '--'}}
                </detail-list-item>
              </detail-list>
              <!--
              <template v-if="model.meterType==80">
                <a-divider orientation="left">
                  解析数据
                </a-divider>
                <detail-list :col="1">
                  <detail-list-item term="解析内容">
                    <a-textarea v-model="model.meterUpDetail" :rows="3"></a-textarea>
                  </detail-list-item>
                </detail-list>
              </template>
              -->
            </div>
            <a-table
                v-else-if="activeKey != 1"
                ref="table"
                size="middle"
                :scroll="{y:'calc(70vh - 160px)'}"
                :pagination="false"
                bordered
                rowKey="id"
                :columns="activeKey == 4?columss:columns"
                :dataSource="dataSource"
                :loading="loading"
                class="j-table-force-nowrap"
                >
              </a-table>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </j-modal>
</template>
<script>
  import pick from 'lodash.pick'
  import {isNull} from '@/utils/validate'
  import {getNextDate,getDateTimeByMiniteInterval} from '@/utils/util'
  import {netTypeObj,Mn100FkStatusObj,SendWayObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item

  export default {
    name: 'MeterUpDataRecordForm',
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        title:this.$t("操作"),
        meterTypeObj,
        model: {},
        netTypeObj,
        Mn100FkStatusObj,
        SendWayObj,
        confirmLoading: false,
        bodyStyle: {
          height: '70vh',
          'overflow-y': 'hidden'
        },
        visible: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUpDataRecord/add",
          edit: "/jeecg-charge/meter/meterUpDataRecord/edit",
          queryById: "/jeecg-charge/meter/meterUpDataRecord/queryById"
        },
        activeKey: 1,
        tabList: [

        ],
        formateRemarkObj: {
          intervalFlowList: [],// 间隔流量
          crowFlowList : [],// 密集采样数据
          daySumFlowList: [],// 日结累计流量
        },
        loading: false,
        dataSource: []
      }
    },
    computed: {
      // i18n：列定义使用 computed 以响应语言切换
      columss () {
        return [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            }
          }, {
            title: this.$t('时间'),
            align: "center",
            dataIndex: 'date'
          }, {
            title: this.$t('日结累计流量(m³)'),
            align: "center",
            dataIndex: 'total'
          }
        ]
      },
      columns () {
        return [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            }
          }, {
            title: this.$t('时间'),
            align: "center",
            dataIndex: 'date'
          }, {
            title: this.$t('流量(m³)'),
            align: "center",
            dataIndex: 'total'
          }
        ]
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.formateRemarkObj = this.$options.data.call(this).formateRemarkObj
        this.model = Object.assign({}, record);
        if (this.model.meterType!=80) {
          this.tabList = [
            {key: 1,title: this.$t('基本信息')}
          ]
          // if(this.model.meterType=='20-2') {
          //   this.tabList = [
          //   {key: 1,title: '基本信息'},
          //   {key: 2,title: '间隔流量'},
          // ]
          // }
          
        } else {
          this.tabList = [
            {key: 1,title: this.$t('基本信息')},
            {key: 2,title: this.$t('间隔流量')},
            {key: 3,title: this.$t('密集流量')},
            {key: 4,title: this.$t('日结累计流量')}
          ]
        }
        this.visible = true;
        if(this.model.meterSignalStrength) {
          this.model.meterSignalStrength = JSON.parse(this.model.meterSignalStrength)
        }
        this.formateRemark(this.model.meterUpDetail)
        // this.$nextTick(() => {
        //   this.form.setFieldsValue(pick(this.model,'meterId','meterType','meterTime','upDate','sysTime','meterSignalStrength','meterTotalUse','meterJsrUse','meterRemainNum','meterBatteryVoltage','meterDayUse','meterDayHighFlow','meterDayHighTime','meterStatus1','meterStatus2','meterStatus3','meterStatus4','meterSaveFault','meterUpWay','meterBatteryStatus','meterValueStatus','meterMagnetic','meterUpTimes','meterUpNoResponse','meterUpData','meterIotType','meterDevId','meterAppId','remark','createTime','createBy'))
        // })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'meterId','meterType','meterTime','upDate','sysTime','meterSignalStrength','meterTotalUse','meterJsrUse','meterRemainNum','meterBatteryVoltage','meterDayUse','meterDayHighFlow','meterDayHighTime','meterStatus1','meterStatus2','meterStatus3','meterStatus4','meterSaveFault','meterUpWay','meterBatteryStatus','meterValueStatus','meterMagnetic','meterUpTimes','meterUpNoResponse','meterUpData','meterIotType','meterDevId','meterAppId','remark','createTime','createBy'))
      },
      formateRemark(data) {
        // 格式化remark的值显示为列表格式
        let remark = JSON.parse(data)
        if(!remark) {
          return
        }
        console.log(remark)
        let tag6 = remark.tag6 // 间隔流量
        let tag7 = remark.tag7 // 密集采样数据
        let tag21 = remark.tag21 // 日结累计流量
        let tag2 = remark.tag2 // 实时数据
        if(tag6) {
          let date = getNextDate(this.model.meterTime.substr(0,10),-1)
          let timeArr = getDateTimeByMiniteInterval(0,0,tag6.recordInterval,tag6.recordCount)
          for(let i = 0;i< tag6.recordCount;i++) {
            let dateTime = ''
            if(timeArr[i] == '24:00') {
              dateTime = this.model.meterTime.substr(0,10)+" 00:00"
            }else{
              dateTime = date + ' ' + timeArr[i]
            }
            if(tag6.positiveSumFlow[i]<0) {
              this.formateRemarkObj.intervalFlowList.push({id: i, total: this.$t('无数据'),date: dateTime})
            }else{
              this.formateRemarkObj.intervalFlowList.push({id: i, total: (tag6.positiveSumFlow[i]/1000).toFixed(2),date: dateTime})
            }
          }
        }
        if(tag7) {
          let date = getNextDate(this.model.meterTime.substr(0,10),-1)
          let timeArr = getDateTimeByMiniteInterval(parseInt(tag7.startTime.substr(0,2)),parseInt(tag7.startTime.substr(2,2))+tag7.recordInterval,tag7.recordInterval,tag7.recordCount)
          for(let i = 0;i< tag7.recordCount;i++) {
            let dateTime = date + ' ' + timeArr[i]
            this.formateRemarkObj.crowFlowList.push({id: i, total: tag7.positiveSumFlow[i]<0?this.$t('无数据'):(tag7.positiveSumFlow[i]/1000).toFixed(2),date: dateTime})
          }
        }
        if(tag21&&tag21.positiveSumFlow) {
          for(let i = 0;i< tag21.recordCount;i++) {
            let myDate = new Date()
            let str = (myDate.getFullYear()+'').substr(0,2)+''+tag21.startDate.substr(0,2)+'-'+tag21.startDate.substr(2,2)+'-'+tag21.startDate.substr(4,2)
            let date = getNextDate(str,-(i))
            if(i==0) {
              date = (myDate.getFullYear()+'').substr(0,2)+''+tag21.startDate.substr(0,2)+'-'+tag21.startDate.substr(2,2)+'-'+tag21.startDate.substr(4,2)
            }
            if(isNull(tag21.positiveSumFlow)||isNull(tag21.positiveSumFlow[i])||tag21.positiveSumFlow[i]<0) {
              this.formateRemarkObj.daySumFlowList.push({id: i, total: this.$t('无数据'),date: date})
            }else{
              this.formateRemarkObj.daySumFlowList.push({id: i, total: tag21.positiveSumFlow[i]/1000,date: date})
            }
          }
        }
        if(tag2) {
          this.model.sumSuccessCount = tag2.sumSuccessCount;
          this.model.sumFailedCount = tag2.sumFailedCount;
          this.model.innerTemp = tag2.innerTemp;
          this.model.remainMoneyFlag = tag2.remainMoneyFlag;
          this.model.meterWarnMoney = tag2.meterWarnMoney;
        }
      },
      changeTab() {
        // 切换tab
        console.log(this.activeKey)
        this.dataSource = this.activeKey == 2?this.formateRemarkObj.intervalFlowList:this.activeKey == 3? this.formateRemarkObj.crowFlowList: this.formateRemarkObj.daySumFlowList
      },
      close () {
        this.$emit('close');
        this.activeKey = 1;
        this.tabList = [];
        this.formateRemarkObj = this.$options.data.call(this).formateRemarkObj;
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .content{
  line-height: normal;
}
</style>